export default "__VITE_ASSET__K1eTif$o__"